import { Color, Flex, Input, Spacing, Text, Textarea } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useAutomaticPaymentRemindersModalForm } from '../../../../../../contexts/automaticPaymentRemindersModalFormContext'

const EMAIL_BODY_ROWS_COUNT = 6
const EMAIL_BODY_MAX_HEIGHT = 160

export const AutomaticPaymentRemindersEmailFields = (): ReactElement => {
  const { t } = useTranslation()
  const { automaticPaymentRemindersModalForm } = useAutomaticPaymentRemindersModalForm()
  const { organization } = useUserOrganization()
  const { FormItem, watch } = automaticPaymentRemindersModalForm

  const emailSubject = watch('emailSubject')

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Flex flexDirection="column" gap={Spacing.S4}>
        <FormItem
          label={t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.email_subject.label')}
          name="emailSubject"
          render={({ field }) => <Input {...field} />}
        />
        <Text color={Color.Grey700} inline variant="bodySM">
          {t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.email_subject.preview', {
            email: organization?.email,
            emailSubject,
          })}
        </Text>
      </Flex>
      <FormItem
        label={t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.email_message.label')}
        name="emailBody"
        render={({ field }) => (
          <Textarea {...field} maxHeight={EMAIL_BODY_MAX_HEIGHT} resizable rows={EMAIL_BODY_ROWS_COUNT} />
        )}
      />
    </Flex>
  )
}
